// Vue
import {mixins} from 'vue-class-component'
import {Component, Prop, Vue} from 'vue-property-decorator'
// Template
import template from './template.vue'
// Components
import {Input} from "../input/Input";
import {Button} from "../button/Button";
import {Select} from "../select/Select";
import {SelectOption} from "../select/option/SelectOption";
import {FormInput} from "../../../mixins/form_input/FormInput";

@Component({
    name: 'AbhVerkaufteEinheiten',
    components: {
        MgsInput: Input,
        MgsButton: Button,
        MgsSelect: Select,
        MgsSelectOption: SelectOption
    },
    mixins: [
        template,
    ]
})
export class AbhVerkaufteEinheiten extends mixins(FormInput) {

    @Prop()
    public name!: string

    @Prop()
    public years!: number[]

    @Prop()
    public value!: object

    @Prop()
    public disabled!: boolean

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop({default: true})
    public showErrors!: boolean

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null )
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0  ? `${this.$appPrefix}-abh-verkaufte-einheiten--error wb-e-inp-1--has-error` : ''
    }

    private selectedYear: string | null = null;

    private amount: string | null = null

    private get isInputValid() {
        return this.amount != null && /^[0-9]+$/.test(this.amount)
            && this.selectedYear
    }

    private get finalOptions() {
        return this.years.filter(year => {
            return this.value[year] == undefined
        })
    }

    private onAdd(event) {
        if (this.selectedYear && this.amount && this.isInputValid) {
            this.$emit('input', { ...this.value, [this.selectedYear]: this.amount })
            this.amount = null;
            this.selectedYear = null;
        }
    }

    private onDelete(year) {
        let newValue = {...this.value}
        delete newValue[year]
        this.$emit('input', newValue);
    }
}